import { useState, useEffect } from 'react';
import './AddWallet.css';
import { addWallet, userStatistics } from '../../utils/api';
import { resources } from '../../utils/resources';
import { useUI } from '../../hooks/useUI';
import { useNow } from '../../hooks/useNow';
import Timer from '../Timer/Timer';
import CustomAlert from '../CustomAlert/CustomAlert';

const AddWallet = (props) => {
    const { userData, setUserData, startNewTimer, timers, closeModal, submitBtnState, setSubmitBtnState } = useUI();

    const [walletAddress, setWalletAddress] = useState('');
    const [isHidden, setIsHidden] = useState(true);
    const [isValid, setIsValid] = useState(true);
    const [amount, setAmount] = useState('');
    const [address, setAddress] = useState('');
    const [memo, setMemo] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [loadingText, setLoadingText] = useState('Loading');
    const [startAt, setStartAt] = useState(null);

    const [alertText, setAlertText] = useState('');
    const [alertKey, setAlertKey] = useState(0);

    // Анимация точек
    useEffect(() => {
        if (!isLoading) return;

        const dots = ['', '.', '..', '...'];
        let index = 0;

        const interval = setInterval(() => {
            setLoadingText(`Loading${dots[index]}`);
            index = (index + 1) % dots.length;
        }, 500);

        return () => clearInterval(interval);
    }, [isLoading]);

    // Управление таймером
    const now = useNow(1000, !!startAt);
    const msToEnd = startAt ? Math.max(0, 600000 - (now - startAt)) : 0;
    const isTimerEnded = msToEnd === 0;

    // Оповещение при завершении таймера
    useEffect(() => {
        if (isTimerEnded && startAt) {
            setStartAt(null);
        }
    }, [isTimerEnded, startAt]);

    const isStellarAddress = (address) => {
        const regex = /^G[A-Z2-7]{55}$/;
        const trimmedAddress = address.trim();
        console.log('isStellarAddress result:', regex.test(trimmedAddress), 'Address:', trimmedAddress);
        return regex.test(trimmedAddress);
    };

    const validateWalletAddress = async () => {
        if (walletAddress && isStellarAddress(walletAddress)) {
            setIsHidden(false);
            setIsValid(true);
            setIsLoading(true);
            setSubmitBtnState(false); // Отключаем кнопку во время загрузки

            try {
                let { result } = await addWallet(window.Telegram.WebApp.initData, walletAddress);

                let data = result;
                console.log(data);

                if (data === true) {
                    const newStartAt = Date.now();
                    setStartAt(newStartAt);

                    const response = await userStatistics(window.Telegram.WebApp.initData);
                    setUserData(response.result);

                    setWalletAddress('');
                    setIsHidden(true);
                    setIsValid(true);
                    setIsLoading(false);
                    setSubmitBtnState(true);

                    return closeModal('modalWindow');
                }

                if (data !== true) {
                    setAmount(data.amount);
                    setAddress(data.address);
                    setMemo(data.memo);
                    const newStartAt = Date.now();
                    setStartAt(newStartAt);
                }

                const response = await userStatistics(window.Telegram.WebApp.initData);
                setUserData(response.result);

            } catch (error) {
                console.error('Error in validateWalletAddress:', error);
                setIsValid(false);
                setIsHidden(true);
            } finally {
                setIsLoading(false);
                setSubmitBtnState(true);
            }
        } else {
            setIsValid(false);
        }
    };

    // Проверка, заполнены ли все инпуты
    const areInputsFilled = () => {
        return walletAddress.trim() !== '';
    };

    // Обработчик нажатия Enter
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' && areInputsFilled() && submitBtnState) {
            validateWalletAddress();
            // Снимаем фокус со всех инпутов
            document.activeElement.blur();
        }
    };

    const copyFunc = (value) => async (e) => {
        if (value) {
            await navigator.clipboard.writeText(value);
            setAlertText('Copied!');
            setAlertKey((prev) => prev + 1);
        }
    };

    return (
        <div className="addWallet">
            <CustomAlert key={alertKey} text={alertText} />
            <div className="addWallet__top">
                <input
                    type="text"
                    placeholder="Enter wallet address"
                    value={walletAddress}
                    onChange={(e) => {
                        setWalletAddress(e.target.value);
                        setIsValid(true);
                    }}
                    onKeyDown={handleKeyDown} // Добавляем обработчик Enter
                    id="input_add-wallet"
                    className={`addWallet__input ${isValid ? '' : 'addWallet__input--error'}`}
                />
                <button
                    className="addWallet__btn"
                    onClick={validateWalletAddress}
                    disabled={!submitBtnState}
                >
                    Submit
                </button>
            </div>
            <div
                id="add-wallet_hidden-block"
                className={`addWallet__inputsBlock ${isHidden ? 'addWallet__inputsBlock--hidden' : ''}`}
            >
                <div className="addWallet__inputBlock">
                    <div className="addWallet__inputBlockTitle appearanceAnimation">Amount of deposits</div>
                    <input
                        type="text"
                        className={`addWallet__input ${isLoading ? 'addWallet__input--loading' : ''}`}
                        value={isLoading ? loadingText : amount}
                        readOnly={true}
                    />
                    <button
                        className="addWallet__inputBlockCopy"
                        style={{ backgroundImage: `url(${resources.icons.copy})` }}
                        onClick={copyFunc(amount)}
                    ></button>
                </div>
                <div className="addWallet__inputBlock">
                    <div className="addWallet__inputBlockTitle appearanceAnimation">Stellar Address</div>
                    <input
                        type="text"
                        className={`addWallet__input ${isLoading ? 'addWallet__input--loading' : ''}`}
                        value={isLoading ? loadingText : address}
                        readOnly={true}
                    />
                    <button
                        className="addWallet__inputBlockCopy"
                        style={{ backgroundImage: `url(${resources.icons.copy})` }}
                        onClick={copyFunc(address)}
                    ></button>
                </div>
                <div className="addWallet__inputBlock">
                    <div className="addWallet__inputBlockTitle appearanceAnimation">Tag/Memo</div>
                    <input
                        type="text"
                        className={`addWallet__input ${isLoading ? 'addWallet__input--loading' : ''}`}
                        value={isLoading ? loadingText : memo}
                        readOnly={true}
                    />
                    <button
                        className="addWallet__inputBlockCopy"
                        style={{ backgroundImage: `url(${resources.icons.copy})` }}
                        onClick={copyFunc(memo)}
                    ></button>
                </div>
                <div className="addWallet__timer">
                    <Timer
                        countdown={msToEnd}
                        text="Till link reset"
                        id="addWallet"
                        autoCount={false}
                        test={startAt}
                        reverseProgress={true}
                        externalNow={now}
                    />
                </div>
            </div>
        </div>
    );
};

export default AddWallet;